import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from '../../shared/reactSelect/select.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import NotificationsGrid from './notificationsGrid.component';
import { filterSelectFactory } from '../../utils/dropdownsHelpers';
import {
  selectPeriodForNotifications,
  selectConnectionForNotifications,
  fetchInitialDataForNotificationsPage,
  resetDataForNotificationsPage,
} from '../store/actions';
import { notificationsPropType } from './propTypes';
import { connectionsOptionsSelector, periodsSelector } from '../../shared/store/selectors';
import { isLoadingNotificationsSelector } from '../store/selectors';
import SecondaryMenu from '../../menu/secondaryMenu.component';

const filterSelectDefault = filterSelectFactory();

class NotificationsPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    connections: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
    connection: PropTypes.shape({
      connName: PropTypes.string,
    }),
    selectPeriodForNotifications: PropTypes.func.isRequired,
    selectConnectionForNotifications: PropTypes.func.isRequired,
    fetchInitialDataForNotificationsPage: PropTypes.func.isRequired,
    resetDataForNotificationsPage: PropTypes.func.isRequired,
    notifications: notificationsPropType,
    notificationsLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.props.fetchInitialDataForNotificationsPage();
  }

  componentWillUnmount() {
    this.props.resetDataForNotificationsPage();
  }

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    const period = periods.find(period => period.value === value);

    this.props.selectPeriodForNotifications(period);
  };

  selectConnection = selectedConnection => {
    const value = selectedConnection ? selectedConnection.value : null;

    this.props.selectConnectionForNotifications(value);
  };

  render() {
    const {
      connection,
      connections,
      notifications,
      notificationsLoading,
    } = this.props;

    const selectedConnection = connection ? connection.connName : '';

    return (
      <div className="notifications-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
          <Select
            clearable={false}
            filterOption={filterSelectDefault}
            name="connection"
            options={connections}
            onChange={this.selectConnection}
            scrollMenuIntoView={false}
            value={selectedConnection}
            className="select-connection"
            virtualized
          />
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters">
              <div className="col">
                <NotificationsGrid
                  notifications={notifications}
                  notificationsLoading={notificationsLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  period: state.shared.period,
  periods: periodsSelector(state),
  connections: connectionsOptionsSelector(state),
  connection: state.shared.connection,
  notifications: state.balanceSheetManagement.shared.notifications,
  notificationsLoading: isLoadingNotificationsSelector(state),
}), {
  selectPeriodForNotifications,
  selectConnectionForNotifications,
  fetchInitialDataForNotificationsPage,
  resetDataForNotificationsPage,
})(NotificationsPage);
